import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import LayoutGap from "%/dynamic-component-editor/options/layout-gap";
import VerticalLayoutAlign from "%/dynamic-component-editor/options/vertical-layout-align";
import VerticalLayoutVerticalAlign from "%/dynamic-component-editor/options/vertical-layout-vertical-align";
import LayoutDirection from "%/dynamic-component-editor/options/layout-direction";
import Overflow from "%/dynamic-component-editor/options/overflow";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import MaxWidth from "%/dynamic-component-editor/options/max-width";
import MaxHeight from "%/dynamic-component-editor/options/max-height";
import MinHeight from "%/dynamic-component-editor/options/min-height";
import MinWidth from "%/dynamic-component-editor/options/min-width";
import LayoutWrap from "%/dynamic-component-editor/options/layout-wrap";

export default class RootLayoutPositionOptions extends BaseOptionsBundle {
  optionTitle = "Layout";
  static optionClassName = "i-dynamic-root-layout-position";
  inspectorToolGroup = "layout";
  static userInterfaceComponent = {
    component: inspectorTools.VERTICAL_POSITION_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      new LayoutWidth({
        "default": "fill",
      }, {
        disable: true,
        message: "Width is not available for root layout",
        force: true,
      }),
      new LayoutHeight({
        "default": "fill",
      }, {
        disable: true,
        message: "Height is not available for root layout",
        force: true,
      }),
      MaxWidth,
      MaxHeight,
      MinHeight,
      MinWidth,
      new LayoutDirection({
        "default": "vertical",
        "hover": "vertical",
      }, {
        disable: true,
        message: "Direction is not available for root layout",
        force: true,
      }),
      new Overflow({
        "default": "auto",
        "hover": "auto",
      }, {
        disable: true,
        message: "Overflow is not available for root layout",
        force: true,
      }),
      VerticalLayoutAlign,
      VerticalLayoutVerticalAlign,
      LayoutGap,
      LayoutWrap,
    ]);
  }
}
